<div class="flex flex-wrap gap-2">
  @if (asDropdown) {
    <app-layer-dropdown [globalSelector]="true"></app-layer-dropdown>
  } @else {
    @for (dataLayer of dataLayers; track dataLayer.year) {
      @if ($index < visibleCount) {
        @if (selectionMode === 'global') {
          <app-year-button
            [dataLayer]="dataLayer"
            [dataIsPublished]="
              indicatorId
                ? dataStore.isPublished(dataLayer._id, indicatorId)
                : null
            "></app-year-button>
        } @else {
          <app-year-select-button
            [dataLayer]="dataLayer"></app-year-select-button>
        }
      }
    }
    @if (hiddenCount > 0) {
      <p-button
        size="small"
        (click)="showAll()"
        [label]="'+' + hiddenCount"
        [rounded]="true"
        [outlined]="true"></p-button>
    }
  }
</div>
